export function isflag (data) {
    if(data || data === 0 || data === '0'){
        return true
    }else{
        return false
    }
}